// generated from 150_942 samples

import { z } from "zod";
// eslint-disable-next-line local-eslint-rules/enforce-namespace-modularity
import sharedConstants from "@lib/shared_constants.json";

import { common } from "../common";
import { messageGetBaseSchema } from "./messageGetBaseSchema";
import type { SubscriptionGroupChannelsReadonlyEnum } from "./types";

const subscriptionGroupChannels: SubscriptionGroupChannelsReadonlyEnum = Object.values(
  sharedConstants.SUBSCRIPTION_GROUP_CHANNELS
) as unknown as SubscriptionGroupChannelsReadonlyEnum;

export const smsMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("sms"),
  // undefined: 17_062 (11.30%), defined 133_880 (88.70%)
  // null: 261 (0.19%)
  body: z.string().nullable().optional(),
  // avg: 306245054.44, min: 0, max: 1749524905
  last_sent_sms: z.int().min(0),
  // undefined: 17_062 (11.30%), defined 133_880 (88.70%)
  // null: 8_510 (6.36%)
  // true 98_388 (78.48%), false 26_982 (21.52%)
  link_shortening_enabled: z.boolean().nullable().optional(),
  // null: 10 (0.01%)
  link_template_ids: z.array(z.string()).nullable(),
  // undefined: 17_062 (11.30%), defined 133_880 (88.70%)
  media_items: z
    .array(
      z.object({
        // true 499 (16.55%), false 2_516 (83.45%)
        is_custom_image_url: z.boolean(),
        // null: 54 (1.79%)
        url: z.string().nullable(),
      })
    )
    .optional(),
  optimal_send_percentage: z.int().min(0).max(100).nullable(),
  // undefined: 17_062 (11.30%), defined 133_880 (88.70%)
  // null: 1_671 (1.25%)
  protocol: z
    .enum([
      "sms", // 131_652 (99.58%)
      "rcs", // 236 (0.18%)
    ])
    .nullable()
    .optional(),
  // undefined: 17_062 (11.30%), defined 133_880 (88.70%)
  // null: 133_641 (99.82%)
  rcs_message: z
    .discriminatedUnion("type", [
      // "media" 78 (32.64%)
      z.object({
        type: z.literal("media"),
        actions: z.array(
          z.discriminatedUnion("type", [
            // "reply" 58 (72.50%)
            z.object({
              type: z.literal("reply"),
              text: z.string(),
            }),
            // "url" 22 (27.50%)
            z.object({
              type: z.literal("url"),
              text: z.string(),
              url: z.string(),
            }),
          ])
        ),
        // undefined: 18 (23.08%), defined 60 (76.92%)
        body: z.string().optional(),
        // undefined: 48 (61.54%), defined 30 (38.46%)
        fallback_message: z
          .object({
            // null: 13 (43.33%)
            body: z.string().nullable(),
            type: z.literal("text"),
          })
          .optional(),
        // undefined: 5 (6.41%), defined 73 (93.59%)
        media_url: z.string().optional(),
      }),
      // "text" 161 (67.36%)
      z.object({
        type: z.literal("text"),
        actions: z.array(
          z.discriminatedUnion("type", [
            // "reply" 147 (85.96%)
            z.object({
              type: z.literal("reply"),
              text: z.string(),
            }),
            // "url" 24 (14.04%)
            z.object({
              type: z.literal("url"),
              text: z.string(),
              url: z.string(),
            }),
          ])
        ),
        // undefined: 4 (2.48%), defined 157 (97.52%)
        body: z.string().optional(),
        // undefined: 76 (47.20%), defined 85 (52.80%)
        fallback_message: z
          .object({
            // null: 46 (54.12%)
            body: z.string().nullable(),
            type: z.literal("text"),
          })
          .optional(),
      }),
      z.object({
        type: z.literal("rich_card"),
        rich_card_type: z.enum(["text", "media"]).optional(),
        actions: z.array(
          z.discriminatedUnion("type", [
            z.object({
              type: z.literal("reply"),
              text: z.string(),
            }),
            z.object({
              type: z.literal("url"),
              text: z.string(),
              url: z.string(),
            }),
          ])
        ),
        buttons: z
          .array(
            z.discriminatedUnion("type", [
              z.object({
                type: z.literal("reply"),
                text: z.string(),
              }),
              z.object({
                type: z.literal("url"),
                text: z.string(),
                url: z.string(),
              }),
            ])
          )
          .optional(),
        body: z.string().optional(),
        title: z.string().optional(),
        height: z.string().optional(),
        media_url: z.string().optional(),
        media_thumbnail_url: z.string().optional(),
        alignment: z.enum(["LEFT", "RIGHT"]).optional(),
        orientation: z.enum(["VERTICAL", "HORIZONTAL"]).optional(),
        fallback_message: z
          .object({
            body: z.string().nullable(),
            type: z.literal("text"),
          })
          .optional(),
      }),
    ])
    .nullable()
    .optional(),
  // undefined: 17_062 (11.30%), defined 133_880 (88.70%)
  // null: 14_099 (10.53%)
  selected_messaging_service: z
    .object({
      from_addresses: z.array(
        z.object({
          display_type: z.enum([
            "Long Code", // 247_036 (86.22%)
            "Short Code", // 22_829 (7.97%)
            "Alphanumeric Code", // 16_145 (5.63%)
            "RCS Sender", // 505 (0.18%)
          ]),
          display_name: z.string(),
          // format numeric: 269_865 (94.19%)
          from_address: z.string(),
        })
      ),
      id: common.objectId,
      // true 54_732 (45.69%), false 65_049 (54.31%)
      mms_enabled: z.boolean(),
      name: z.string(),
      // true 505 (0.42%), false 119_276 (99.58%)
      rcs_enabled: z.boolean(),
      service_provider: common.numericEnum(subscriptionGroupChannels),
      subscription_group: z.object({
        external_id: z.string(),
        id: common.objectId,
        link_shortening_domain: z.string(),
        name: z.string(),
      }),
    })
    .nullable()
    .optional(),
  // undefined: 17_062 (11.30%), defined 133_880 (88.70%)
  // null: 11_022 (8.23%)
  // true 42_316 (34.44%), false 80_542 (65.56%)
  user_click_tracking_enabled: z.boolean().nullable().optional(),
});
